<template>
	<div class="page-index-mobile column-me row-center" v-if="isMobile"></div>
	<div ref="carouselFull" class="page-index column-me row-center" v-else>
		<div class="all">
			<toubu></toubu>
			<div class="two">
				<img src="../../assets/chenggong/join_banner.png" class="imgBg" />
				<div class="getBack" @click="getBack()">
					<img src="../../assets/fuwuimg/icon_weizhi.png">
					<div>加入我们 > <span>职位详情</span></div>
				</div>
				<div class="details">
					<div class="detailsCen">
						<div class="cenMain">
							<div class="title">{{recruitInfo.position}}</div>
							<div class="info">
								<span>{{recruitInfo.city}} ｜ </span>
								<span>{{recruitInfo.experience}}经验 ｜</span>
								<span>{{recruitInfo.education}} ｜</span>
								<span>{{recruitInfo.sub_time}}发布</span>
							</div>
							<div class="application" @click="dianji(recruitInfo.id)">申请职位</div>
						</div>
						
					</div>
				</div>
				<div class="requireBox">
					<div class="statement">
						<div class="title">岗位职责：</div>
						<div class="txt" v-html="recruitInfo.jobs">
							<!-- {{recruitInfo.jobs}} -->
						</div>
					</div>
					<div class="statement">
						<div class="title">岗位要求：</div>
						<div class="txt" v-html="recruitInfo.require"></div>
					</div>
				</div>
				<!-- <div class="two4">
					<div class="nullBox" v-if="tableData.length == 0"><img src="../../assets/img/null.png" /></div>
					<div class="cenMain" v-for="i in tableData" :key="i.id" v-else>
						<div class="title">{{i.position}}</div>
						<div class="info">
							<span>工作城市：{{i.city}}</span>
							<span>招聘人数：{{i.need}}</span>
							<span>更新时间：{{i.sub_time}}</span>
						</div>
						<div class="application" @click="dianji(i.id)">点击申请</div>
					</div>
				</div> -->
			</div>
			<input type="file" @change="shangchuan" id="btn_file" style="height:0px" value="ffile" />
			<div class="three">
				<el-dialog :visible.sync="dialogVisible" width="50%" height="50%">
					<el-form :inline="true" :model="from">
						<div style="display:flex;justify-content:space-between;">
							<el-form-item label="姓名:">
								<el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
							</el-form-item>

							<el-form-item label="电话:">
								<el-input v-model="form.phone" placeholder="请输入您的电话" maxlength="11"
									oninput="value=value.replace(/[^\d]/g,'')"></el-input>
							</el-form-item>

							<el-form-item label="邮箱:">
								<el-input v-model="form.email" placeholder="请输入您的邮箱"></el-input>
							</el-form-item>
						</div>
						<!-- action="https://www.jxmlove.top/api/Recruit/upIntroduction" :on-success="wancheng"> -->
						<el-upload class="up" style="margin-top:20px" drag
							action="http://mp.boruankeji.net/admin/UpFiles/uploadFiles" :on-success="wancheng">
							<img src="../../assets/chenggong/ncftpput.png" />
							<div class="up1">拖拽或点击选择简历文件到这里即可上传</div>
							<div class="up2">
								简历建议使用PDF文件，也支持DOC、DOCX、JPG、PNG格式，文件大小不超过10M
							</div>
							<div class="el-upload__text">
								<em class="up3">上传简历</em>
							</div>

							<!-- <div class="el-upload__tip" slot="tip">
                只能上传jpg/png文件，且不超过500kb
              </div> -->
						</el-upload>
						<div class="up4">
							<div class="up41">
								<div class="up411" @click="dialogVisible = false">取消</div>
							</div>
							<div class="up42" @click="tijiao">提交</div>
						</div>
					</el-form>
				</el-dialog>
			</div>
			<dibu></dibu>
		</div>
	</div>
</template>

<script>
	import Toubu from "@/components/header.vue";
	import Dibu from "@/components/footer.vue";
	import {
		Message
	} from "element-ui";
	export default {
		data() {
			return {
				isMobile: this.$store.state.isMobile === 1,
				tableData: [],
				dialogVisible: false,
				form: {},
				imgurl: "",
				id: "",
				recruitInfo:{},
			};
		},
		components: {
			Toubu,
			Dibu
		},
		computed: {
			windowChange() {
				return this.$store.state.isMobile;
			},
		},
		mounted() {
			//获取职位
			this.$post(this.$host + "/index/Recruit/recruitInfo",{
				id: this.$route.query.id
			}).then((res) => {
				this.recruitInfo = res.data;
			});
		},
		watch: {
			windowChange: function(newVal, oldVal) {
				this.isMobile = newVal === 1;
			},
		},
		methods: {
			tijiao() {
				if (this.form.name == undefined || this.form.name == '') {
					Message.error({
						message: "姓名不能为空！",
					});
					return false
				}
				console.log(this.form.phone, '206')
				if (this.form.phone == undefined || this.form.phone == '') {
					Message.error({
						message: "电话不能为空！",
					});
					return false
				}
				if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
					Message.error({
						message: "请输入正确的手机号！",
					});
					return false;
				}

				if (this.form.email == undefined || this.form.email == '') {
					Message.error({
						message: "邮箱不能为空！",
					});
					return false
				}

				var reg1 = new RegExp("^\\w+@\\w{2,6}(\\.\\w{2,3})+$", "i");
				if (reg1.test(this.form.email)) {
					// alert("2")
				} else {
					Message.error({
						message: "请输入正确的邮箱！",
					});
					return false
				}


				let formData = new FormData();
				formData.append("recruit_id", this.id);
				formData.append("candidates", this.form.name);
				formData.append("email", this.form.email);
				formData.append("phone", this.form.phone);
				formData.append("resume", this.imgurl);
				this.$post(this.$host + "/index/Recruit/subRecruit", formData).then(
					(res) => {
						console.log("简历上传", res);
						this.dialogVisible = false;
						this.form = {};
						if (res.code == 500) {
							Message.error({
								message: res.msg,
							});
						} else {
							Message.success({
								message: res.msg,
							});
						}

					}
				);
			},
			getBack(){
				window.history.go(-1);
			},
			dianji(id) {
				console.log("hah", id);
				this.dialogVisible = true;
				this.id = id;
			},
			handleClick() {
				document.getElementById("btn_file").click();
			},
			shangchuan(e) {
				console.log(e);
				let formData = new FormData();
				const files = e.target.files;
				const file = files[0];
				formData.append("file", file);
				this.$uploadFileRequest(
					// this.$host + "/api/Recruit/upIntroduction",
					this.$host + "/admin/UpFiles/uploadFiles",
					formData
				).then((res) => {
					console.log("上传结果", res);
					// if (res.data.url) {
					if (res.data) {
						let formData = new FormData();
						formData.append("id", this.id);
						formData.append("result", 1);
						formData.append("reason", res.data);
						this.$post(this.$host + "/admin/entrust/check", formData).then(
							(res) => {
								this.refresh();
							}
						);
					}
				});
			},
			wancheng(res) {
				console.log("res298", res);
				this.imgurl = res.data;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.one {
		width: 100vw;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		flex-direction: row;

		.one1 {
			margin-top: 170px;
		}

		.one2 {
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #dcdcdc;
			border: 1px solid #d2d2d2;
			border-radius: 4px;
			width: 200px;
			height: 48px;
			margin-top: 400px;
			position: absolute;
			padding: auto auto;

			.one21 {
				position: absolute;
				text-align: center;
				left: 0;
				right: 0;
				line-height: 48px;
				cursor: pointer;
			}
		}
	}

	.two {
		width: 100vw;
		padding-bottom: 104px;

		.imgBg {
			width: 100vw;
		}
		.getBack {
			width: 1300px;
			margin: 0 auto;
			margin-top: 49px;
			display: flex;
			align-items: center;
			cursor: pointer;
		
			img {
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		
			div {
				font-size: 24px;
				color: #999999;
		
				span {
					color: #126CE7;
				}
			}
		}
		.details{
			width: 100%;
			height: 200px;
			background: #F5F8FE;
			margin-bottom: 50px;
			margin-top: 50px;
			overflow: hidden;
			.detailsCen{
				width: 1300px;
				margin: 0 auto;
				overflow: hidden;
				.cenMain {
					// background: indianred;
					// width: 67vw;
					display: flex;
					flex-direction: column;
					justify-content: center;
					height: 150px;
					margin: 0 auto;
					position: relative;
				
					.title {
						font-size: 24px;
						color: #222222;
						margin-bottom: 27px;
						margin-top: 45px;
					}
				
					.info {
						font-size: 22px;
						color: #7F8393;
						// margin-left: 39px;
					}
				
					.application {
						width: 140px;
						height: 60px;
						line-height: 60px;
						background: #126CE7;
						text-align: center;
						font-size: 22px;
						color: #fff;
						position: absolute;
						right: 0;
						top: 85px;
						cursor: pointer;
					}
				}
			}
			
		}
		.requireBox{
			width: 1300px;
			margin: 0 auto;
			.statement{
				margin-bottom: 81px;
				.title{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #2C2F42;
					margin-bottom: 29px;
				}
				.txt{
					font-size: 18px;
					font-family: Source Han Sans CN;
					color: #2C2F42;
				}
			}
			.statement:last-child{
				margin-bottom: 0;
			}
		}
		
		.two1 {
			text-align: center;
			font-size: 40px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			padding-top: 59px;
			padding-bottom: 23px;
			// margin-top: 59px;
		}

		.two2 {
			display: flex;
			justify-content: center;

			.two22 {
				width: 180px;
				height: 1px;
				background: rgba(128, 128, 128, 0.616);
				margin-right: 1vw;
			}

			.two21 {
				width: 40px;
				height: 3px;
				background: #ffae67;
			}

			.two23 {
				width: 180px;
				height: 1px;
				background: rgba(128, 128, 128, 0.616);
				margin-left: 1vw;
			}
		}

		.two3 {
			margin-top: 24px;
			display: flex;
			justify-content: center;
			color: rgba(0, 0, 0, 0.418);
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #999999;
		}

		.two4 {
			margin-top: 68px;

			.nullBox {
				width: 500px;
				margin: 0 auto;
				margin-top: 50px;

				img {
					margin: 0 auto;
				}
			}

			.cenMain {
				// background: indianred;
				width: 67vw;
				display: flex;
				flex-direction: column;
				justify-content: center;
				height: 150px;
				margin: 0 auto;
				position: relative;

				.title {
					font-size: 24px;
					color: #222222;
					margin-bottom: 27px;
					margin-left: 39px;
				}

				.info {
					font-size: 22px;
					color: #7F8393;
					margin-left: 39px;

					span {
						margin-right: 38px;
					}
				}

				.application {
					width: 120px;
					height: 50px;
					line-height: 50px;
					border-radius: 25px;
					text-align: center;
					font-size: 22px;
					color: #2276F5;
					position: absolute;
					right: 39px;
					top: 55px;
					cursor: pointer;
				}
			}

			.cenMain:hover {
				background: url(../../assets/chenggong/listBg.png);
				background-size: 100% 100%;
				box-shadow: 0px 0px 20px 0px rgba(153, 153, 153, 0.2);

				.application {
					color: #fff;
					background: #126CE7;
					border-radius: 25px;
				}
			}



			.two41 {
				margin-left: 15vw;
				margin-top: 51px;

				td {
					height: 100px;
				}

				/deep/.el-table {}

				/deep/.el-table__body tr:hover>td {
					color: #126ce7;
					background: #e9f3ff;
				}

				/deep/.el-table__body tr:hover>* {
					color: #126ce7;
					background: #e9f3ff;
				}
			}
		}
	}

	.up {
		margin: 0 auto;

		/deep/.el-upload-dragger {
			background-color: #fff;
			border: 0.013333rem dashed #d9d9d9;
			border-radius: 0.08rem;
			box-sizing: border-box;
			width: 48vw;
			height: 30vh;
			text-align: center;
			position: relative;
			overflow: hidden;
			margin: 0 auto;
		}

		img {
			margin: 0 auto;
			margin-top: 18px;
		}

		.up1 {
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #666666;
		}

		.up2 {
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #999999;
			margin-top: 19px;
		}

		.up3 {
			margin-top: 19px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #126ce7;
		}
	}

	.up4 {
		display: flex;
		justify-content: center;
		margin-top: 46px;

		.up41 {
			width: 200px;
			height: 60px;
			background: #a9b6c4;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #ffffff;
			text-align: center;
			line-height: 60px;
			cursor: pointer;
		}

		.up42 {
			width: 200px;
			height: 60px;
			background: #126ce7;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: white;
			text-align: center;
			line-height: 60px;
			margin-left: 60px;
			cursor: pointer;
		}
	}
</style>
